angular
  .module('ordersCancelReasons')
  .component('ordersCancelReasons', {
    template: require('./orders-cancel-reasons.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function OrdersCancelReasonsController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'cancelReasons';
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.showUserView = $rootScope.gShowUserView;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.reasons = {};
        this.totalCount = 0;
        $resource(`${APIURL}/admin/reasons/reserve/cancel`).get({}).$promise
          .then((data) => { this.reasons = data.reasons; this.totalCount = data.totalCount; console.log(data); return Promise.resolve(); })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/reasons/reserve/cancel`).get({ PAGE: page - 1, QUERY: this.query }).$promise
            .then((data) => { this.reasons = data.reasons; this.totalCount = data.totalCount; return Promise.resolve(); })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-cancel-reasons/orders-cancel-reasons.component.js